import { render, staticRenderFns } from "./ChartLabelsTable.vue?vue&type=template&id=19a94a83&scoped=true&"
import script from "./ChartLabelsTable.vue?vue&type=script&lang=js&"
export * from "./ChartLabelsTable.vue?vue&type=script&lang=js&"
import style0 from "./ChartLabelsTable.vue?vue&type=style&index=0&id=19a94a83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a94a83",
  null
  
)

export default component.exports